import type { IconColor, IconSize } from '@freelancer/ui/icon';
import type { QueryParams, QueryParamsHandling } from '../link';

export type MoreOptionsIconColor =
  | IconColor.LIGHT
  | IconColor.FOREGROUND
  | IconColor.INHERIT;

export type MoreOptionsIconSize = IconSize.LARGE | IconSize.MID;

export enum MoreOptionsIconType {
  DEFAULT = 'default',
  COG = 'cog',
  MORE_VERT = 'more-vert',
}

export enum MoreOptionsSize {
  XXXSMALL = 'xxxsmall',
  XXSMALL = 'xxsmall',
  XSMALL = 'xsmall',
  SMALL = 'small',
  MID = 'mid',
}

export interface MoreOptionsItemEvent {
  readonly link?: string;
  readonly newTab?: boolean;
  readonly queryParams?: QueryParams;
  readonly queryParamsHandling?: QueryParamsHandling;
  readonly iconName?: string;
  readonly iconSize: IconSize;
  readonly iconColor: IconColor;
  readonly disableCalloutClose: boolean;
  readonly closeOnSelect: boolean;
  readonly closeOnSelectDesktop: boolean;
}
